import Router from '@/router'
function install (Vue) {
  /**
   * Helper Function to create centralized feedback on data portal
   * Will leads to forum for post creation, and emails will be sent automatically
   * @param {Array<String>} owner list of POC
   * @param {String} title
   * @param {String} moduleName
   */
  Vue.prototype.$feedback = (owner, title, moduleName, path) => {
    let tagName = null
    switch (moduleName) {
      case 'dashboard':
        tagName = 'Dashboard'
        break
      case 'golden query':
        tagName = 'Golden Query'
        break
      case 'query pad':
        tagName = 'Query Pad'
        break
    }
    const receiversSet = new Set(['data-eng-team@li.me', 'ruben.kogel@li.me'])
    owner.split(';').forEach(email => {
      receiversSet.add(email.toLowerCase().trim())
    })
    const targetUrl = `${process.env.VUE_APP_APP_URI}${path}`
    const query = {
      feedback: true,
      newpost: true,
      fullscreen: true,
      title: title,
      receiverEmail: [...receiversSet],
      tagName,
      targetUrl
    }

    const routeData = Router.resolve({
      name: 'Forum',
      query
    })
    window.open(routeData.href, '_blank')
  }
}

export default { install }
